(() => {
    const hideClass = 'ocean-hide-widget';
    const root = document.documentElement;

    async function getCartToken() {
        try {
            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            const cart = await res.json();
            const token = cart?.token;
            return token || null;
        } catch (err) {
            console.error('[Ocean A/B] Failed to fetch cart token:', err);
            return null;
        }
    }

    async function getGroupViaAppProxy(cartToken) {
        const shopDomain = window.Shopify?.shop || document.location.host;
        const params = new URLSearchParams({ cart_token: cartToken });
        const url = `/a/ocean/assign_ab_test_group?${params.toString()}`;

        const res = await fetch(url, { method: 'POST' });

        console.log('[Ocean A/B] Response status:', res.status);
        const json = await res.json().catch(() => null);
        const group = json?.data?.group || 'B';
        console.log('[Ocean A/B] Assigned group from BE:', group);

        return group;
    }

    async function syncCartAttributes(cartToken) {
        try {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        ocean_cart_token: cartToken,
                    },
                }),
            });
            console.log('[Ocean A/B] Synced cart attributes:', {
                ocean_cart_token: cartToken,
            });
        } catch (e) {
            console.error('[Ocean A/B] Failed to sync cart attributes:', e);
        }
    }

    async function boot() {
        try {
            console.log('[Ocean A/B] Starting Test');
            const cartToken = await getCartToken();
            if (!cartToken) throw new Error('Missing cart token');

            const group = await getGroupViaAppProxy(cartToken);

            if(group === 'A') {
                root.classList.remove(hideClass);
            }
            else {
                root.classList.add(hideClass);
            }

            await syncCartAttributes(cartToken, group);

            console.log('[Ocean A/B] Completed successfully:', { group, cartToken });
        } catch (e) {
            console.error('[Ocean A/B] Failed to initialize A/B test:', e);
            // On failure → default to Group B (hide widget)
            root.classList.add(hideClass);
        }
    }

    // Run as soon as DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();